import { truncateNumber } from "./truncateNumber";

export function volumeFormat(fileSize: number | undefined, fixed?: number) {
  if (!fileSize) return "0";
  let str: string;

  const format = (size: number) =>
    fixed === undefined ? String(size) : truncateNumber(size, fixed);

  //GB 단위 이상일때 GB 단위로 환산
  if (fileSize >= 1024 * 1024 * 1024) {
    str = format(fileSize / (1024 * 1024 * 1024)) + " GB";
  }
  //MB 단위 이상일때 MB 단위로 환산
  else if (fileSize >= 1024 * 1024) {
    str = format(fileSize / (1024 * 1024)) + " MB";
  }
  //KB 단위 이상일때 KB 단위로 환산
  else if (fileSize >= 1024) {
    str = format(fileSize / 1024) + " KB";
  }
  //KB 단위보다 작을때 byte 단위로 환산
  else {
    str = format(fileSize) + " byte";
  }
  return str;
}
